var map = {
	"./ID.webp": 782,
	"./INDO.webp": 783,
	"./MY.webp": 784,
	"./TH.webp": 785,
	"./VN.webp": 786,
	"./malaysia.webp": 787
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 391;
module.exports = webpackAsyncContext;